import { Box, Typography, Chip, IconButton, Tooltip } from '@mui/material';
import {
  ArticleOutlined,
  ImageOutlined,
  VideoLibraryOutlined,
  DeleteOutline,
  VisibilityOutlined,
} from '@mui/icons-material';

export const getContentTypeIcon = (type: string) => {
  switch (type) {
    case 'article':
      return <ArticleOutlined fontSize="small" />;
    case 'image':
      return <ImageOutlined fontSize="small" />;
    case 'video':
      return <VideoLibraryOutlined fontSize="small" />;
    default:
      return <ArticleOutlined fontSize="small" />;
  }
};

interface TopicCellProps {
  topic: string;
  angle?: string;
}

export const TopicCell = ({ topic, angle }: TopicCellProps) => {
  const shouldShowAngle =
    angle && angle !== 'article' && angle !== 'image' && angle !== 'video';

  return (
    <Box>
      <Typography variant="body2" fontWeight={500}>
        {topic}
      </Typography>
      {shouldShowAngle && (
        <Typography variant="caption" color="text.secondary">
          {angle}
        </Typography>
      )}
    </Box>
  );
};

interface TypeCellProps {
  type: string;
}

export const TypeCell = ({ type }: TypeCellProps) => {
  return (
    <Chip
      icon={getContentTypeIcon(type)}
      label={type}
      size="small"
      sx={{ textTransform: 'capitalize' }}
    />
  );
};

interface StatusCellProps {
  status: string;
}

export const StatusCell = ({ status }: StatusCellProps) => {
  return (
    <Chip
      label={status}
      size="small"
      color={status === 'completed' ? 'success' : 'default'}
      sx={{ textTransform: 'capitalize' }}
    />
  );
};

interface NameCellProps {
  name: string;
}

export const NameCell = ({ name }: NameCellProps) => {
  return (
    <Typography variant="body2" fontWeight={500}>
      {name}
    </Typography>
  );
};

interface ActionsCellProps {
  onView?: () => void;
  onDelete?: () => void;
}

export const ActionsCell = ({ onView, onDelete }: ActionsCellProps) => {
  return (
    <Box>
      <Tooltip title="View">
        <IconButton size="small" onClick={onView}>
          <VisibilityOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete">
        <IconButton size="small" onClick={onDelete}>
          <DeleteOutline fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
